module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-e7a893b6f7d7f95faa63ade87bb8aafe.webp";